<template>
    <div class="cards">
        <vs-tabs position="left">
            <vs-tab
                v-for="(tab, tabName) in getTabs"
                :key="tabName"
                :label="$t(`${tab.text}`)"
                class="h-full"
            >
                <div v-if="tabName === 'card'"  class="m-1 ">
                    <ValidationObserver class="popup-add-domain" ref="formAddCard" v-slot="{handleSubmit}">
                        <vs-row type="flex" class="mt-4 mb-24 flex justify-between">
                            <vs-col vs-w="5.9" class="mb-2" v-for="(value, name) in tab.fields" :key="name">
                                <div>
                                    <label>
                                        <span > {{$t(`${value.text}`)}}</span>
                                    </label>
                                    <ValidationProvider
                                        :vid="$t(value.text)"
                                        :name="$t(`${value.text}`)"
                                        :rules="value.validate"
                                        v-slot="{ errors }"
                                    >
                                        <v-select
                                            v-if="value.field === 'select'"
                                            class="w-full"
                                            :clearable="true"
                                            :options="value.relation ? getRelationsOptions(value, tabName) : options[value.optionName]"
                                            :reduce="option => option[value.propertyId]"
                                            :label="value.propertyName"
                                            v-model="tab.data[value.propertySendToServer]"
                                        />
                                        <datepicker
                                            v-else-if="value.field === 'date'"
                                            :minimumView="'month'"
                                            :maximumView="'year'"
                                            :initialView="'year'"
                                            :format="'MM/yy'"
                                            v-model="tab.data[name]"
                                        />
                                        <vs-input
                                            v-else-if="name === 'card_number'"
                                            class="w-full"
                                            :value="tab.data[name] | maskCard()"
                                            @input="limitMaxNumberChar($event, 16, name)"
                                        />
                                        <vs-input
                                            v-else-if="name === 'cvv_code'"
                                            class="w-full"
                                            :value="tab.data[name]"
                                            @input="limitMaxNumberChar($event, 3, name)"
                                        />
                                        <vs-input
                                            v-else
                                            class="w-full"
                                            v-model="tab.data[name]"
                                        />
                                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                                    </ValidationProvider>
                                </div>
                            </vs-col>
                        </vs-row>
                        <vs-button
                            class="mt-4 float-right"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="handleSubmit(addCards)"
                        >
                            {{popupType === 'editCard' ? $t('buttons.Edit_card') :  $t('buttons.Create_card')}}
                        </vs-button>
                    </ValidationObserver>
                </div>
                <div v-else>
                    <ValidationObserver  ref="createElementCard" v-slot="{handleSubmit, reset}">
                        <div class="z-10 w-full flex justify-end items-center">
                            <vs-checkbox v-model="tab.selectEdit" @input="reset">{{$t('global.edit')}}</vs-checkbox>
                        </div>
                        <vs-row type="flex" class="mt-4 flex justify-between" v-if="!tab.selectEdit">
                            <vs-col vs-w="5.9" class="mb-2" v-for="item in tab.createFields" :key="item.text">
                                <ValidationProvider
                                    :vid="$t(item.text)"
                                    :name="$t(item.text)"
                                    :rules="item.validate"
                                    v-slot="{ errors }"
                                >
                                    <label>
                                        <span> {{$t(`${item.text}`)}}</span>
                                    </label>
                                    <v-select
                                        v-if="item.field === 'select'"
                                        class="w-full"
                                        :clearable="true"
                                        :options="getOptions(item, tabName)"
                                        :reduce="option => option[item.propertyId]"
                                        :label="item.propertyName"
                                        v-model="tab.data[item.propertySendToServer ? item.propertySendToServer : 'id' ]"
                                    />
                                    <vs-input
                                        v-else
                                        class="w-full"
                                        v-model="tab.data[item.propertyName]"
                                    />
                                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                                </ValidationProvider>
                            </vs-col>
                        </vs-row>
                        <vs-row type="flex" class="mt-4 flex justify-between" v-else>
                            <vs-col vs-w="5.9" class="mb-2" v-for="item in tab.editFields" :key="item.text">
                                <ValidationProvider
                                    :vid="$t(item.text)"
                                    :name="$t(item.text)"
                                    :rules="item.validate"
                                    v-slot="{ errors }"
                                >
                                    <label>
                                        <span> {{$t(`${item.text}`)}}</span>
                                    </label>
                                    <v-select
                                        v-if="item.field === 'select'"
                                        class="w-full"
                                        :clearable="true"
                                        :options="getOptions(item, tabName)"
                                        :reduce="option => option[item.propertyId]"
                                        :label="item.propertyName"
                                        v-model="tab.edit[item.propertySendToServer ? item.propertySendToServer : 'id' ]"
                                    />
                                    <vs-input
                                        v-else
                                        class="w-full"
                                        v-model="tab.edit[item.propertyName]"
                                    />
                                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                                </ValidationProvider>
                            </vs-col>
                        </vs-row>
                        <div v-if="tab.selectEdit"  class=" flex absolute right-0 bottom-0">
                            <vs-button
                                class="mr-4"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-minus"
                                :disabled="checkPossibilityRemove(tab)"
                                @click="removeVocabulary(tab, tabName)"
                            >
                                {{ $t('global.remove')}}
                            </vs-button>
                            <vs-button
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-plus"
                                :disabled="checkPossibilityEditing(tab)"
                                @click="saveSettingsVocabulary(tab)"
                            >
                                {{ $t('global.edit')}}
                            </vs-button>
                        </div>
                        <vs-button
                            v-else
                            class="absolute right-0 bottom-0"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="handleSubmit(saveSettingsVocabulary(tab))"
                        >
                            {{ $t('global.create')}}
                        </vs-button>
                    </ValidationObserver>
                </div>
            </vs-tab>
        </vs-tabs>
    </div>
</template>


<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import send from '@/utils/fetch'
import {sorting} from '@/utils/mixins'
import ErrorHandler from '@/utils/errorHandler'
import EventBus from '@/store/eventBus'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

export default {
    name: 'Popup',
    mixins: [sorting],

    components: {
        ValidationObserver,
        ValidationProvider,
        vSelect,
        Datepicker
    },

    data() {
        return {
            tabs: {
                card: {
                    text: 'global.card',
                    fields: {
                        card_type: {
                            text: 'global.Type',
                            field: 'select',
                            propertyId: 'id',
                            propertySendToServer: 'card_type_id',
                            propertyNameInServer: 'type_name',
                            propertyName: 'type_name',
                            optionName: 'card_types',
                            validate: 'required',
                            visibleValueAtEdit: true
                        },
                        card_bank: {
                            text: 'global.bank',
                            field: 'select',
                            propertyId: 'card_bank_id',
                            propertySendToServer: 'card_bank_id',
                            propertyNameInServer: 'bank_name',
                            propertyName: 'bank_name',
                            optionName: 'relations',
                            relation: 'card_invoice_id',
                            validate: 'required',
                            visibleValueAtEdit: true
                        },
                        holder_name: {
                            text: 'global.holder',
                            field: 'select',
                            propertyId: 'id',
                            propertySendToServer: 'card_holder_id',
                            propertyNameInServer: 'holder_name',
                            propertyName: 'holder_name',
                            optionName: 'card_holders',
                            validate: 'required',
                            visibleValueAtEdit: true
                        },
                        invoice: {
                            text: 'global.invoice',
                            field: 'select',
                            propertyId: 'card_invoice_id',
                            propertySendToServer: 'card_invoice_id',
                            propertyNameInServer: 'invoice_number',
                            propertyName: 'number',
                            optionName: 'relations',
                            relation: 'card_bank_id',
                            validate: 'required',
                            visibleValueAtEdit: true
                        },
                        geo: {
                            text: 'global.Geo',
                            field: 'select',
                            propertyId: 'geo_id',
                            propertySendToServer: 'geo_id',
                            propertyNameInServer: 'geo_name',
                            propertyName: 'name',
                            optionName: 'geos',
                            validate: 'required',
                            visibleValueAtEdit: true
                        },
                        card_number: {
                            text: 'global.number',
                            field: 'input',
                            validate: 'required|checkCardNumber',
                            visibleValueAtEdit: false
                        },
                        expired: {
                            text: 'global.Date',
                            field: 'date',
                            validate: 'required',
                            visibleValueAtEdit: false
                        },
                        cvv_code: {
                            text: 'global.cvv',
                            field: 'input',
                            validate: 'required|checkCvvNumber',
                            visibleValueAtEdit: false
                        },
                        comment: {
                            text: 'global.comment',
                            field: 'input',
                            validate: 'required',
                            visibleValueAtEdit: false
                        }
                    },
                    data: {}
                },
                type: {
                    text: 'global.Type',
                    createFields: [
                        {
                            text: 'global.typeName',
                            field: 'input',
                            propertyName: 'type_name',
                            validate: 'required'
                        }
                    ],
                    editFields: [
                        {
                            text: 'global.Type',
                            field: 'select',
                            propertyId: 'id',
                            propertyName: 'type_name',
                            optionName: 'card_types',
                            validate: 'required'
                        },
                        {
                            text: 'global.newTypeName',
                            field: 'input',
                            propertyName: 'type_name',
                            validate: 'required'
                        }
                    ],
                    data:{},
                    edit:{},
                    model: 'CardType',
                    selectEdit: false
                },
                bank: {
                    text: 'global.bank',
                    createFields: [
                        {
                            text: 'global.bankName',
                            field: 'input',
                            propertyName: 'bank_name',
                            validate: 'required'
                        }
                    ],
                    editFields: [
                        {
                            text: 'global.bank',
                            field: 'select',
                            propertyId: 'card_bank_id',
                            propertyName: 'bank_name',
                            optionName: 'relations',
                            validate: 'required'
                        },
                        {
                            text: 'global.newBankName',
                            field: 'input',
                            propertyName: 'bank_name',
                            validate: ''
                        }
                    ],
                    data:{},
                    edit:{},
                    model:'CardBank',
                    selectEdit: false
                },
                holder: {
                    text: 'global.holder',
                    createFields: [
                        {
                            text: 'global.holderName',
                            field: 'input',
                            propertyName: 'holder_name',
                            validate: 'required'
                        }
                    ],
                    editFields: [
                        {
                            text: 'global.holder',
                            field: 'select',
                            propertyId: 'id',
                            propertyName: 'holder_name',
                            optionName: 'card_holders',
                            validate: 'required'
                        },
                        {
                            text: 'global.newHolderName',
                            field: 'input',
                            propertyName: 'holder_name',
                            validate: 'required'
                        }
                    ],
                    model:'CardHolder',
                    data:{},
                    edit:{},
                    selectEdit: false
                },
                invoice: {
                    text: 'global.invoice',
                    createFields: [
                        {
                            text: 'global.bank',
                            field: 'select',
                            propertyId: 'card_bank_id',
                            propertySendToServer: 'card_bank_id',
                            propertyName: 'bank_name',
                            optionName: 'relations',
                            validate: 'required'
                        },
                        {
                            text: 'global.invoiceNumber',
                            field: 'input',
                            propertyName: 'number',
                            validate: 'required'
                        }
                    ],
                    editFields: [
                        {
                            text: 'global.bank',
                            field: 'select',
                            propertyId: 'card_bank_id',
                            propertySendToServer: 'card_bank_id',
                            propertyName: 'bank_name',
                            optionName: 'relations',
                            multiple: true,
                            validate: 'required'
                        },
                        {
                            text: 'global.invoice',
                            field: 'select',
                            optionName: 'relations',
                            propertyId: 'card_invoice_id',
                            propertySendToServer: 'id',
                            propertyName: 'number',
                            relation: 'card_bank_id',
                            validate: 'required'
                        },
                        {
                            text: 'global.newInvoiceNumber',
                            field: 'input',
                            propertyName: 'number',
                            validate: ''
                        }
                    ],
                    data:{},
                    edit:{},
                    selectEdit: false,
                    model:'CardInvoice'
                },
                platforms:{
                    text: 'global.platform',
                    createFields: [
                        {
                            text: 'global.platformName',
                            field: 'input',
                            propertyName: 'platform_name',
                            validate: 'required'
                        }
                    ],
                    editFields: [
                        {
                            text: 'global.platform',
                            field: 'select',
                            propertyId: 'id',
                            propertyName: 'platform_name',
                            optionName: 'card_platforms',
                            validate: 'required'
                        },
                        {
                            text: 'global.newPlatformName',
                            field: 'input',
                            propertyName: 'platform_name',
                            validate: 'required'
                        }
                    ],
                    data:{},
                    edit:{},
                    model: 'CardPlatform',
                    selectEdit: false
                }
            },
            options: {},
            removeAdditionalData: {}
        }
    },

    props: {
        popupData: Object,
        popupType: String
    },

    filters: {
        maskCard(value) {
            if(value) {
                return value.replace(/\d{4}(?=.)/g, '$& ')
            }
        }
    },

    computed: {
        getTabs() {
            if(this.popupType === 'editCard') {
                return {card: this.tabs.card}
            } else {
                return this.tabs
            }
        }
    },

    methods: {
        limitMaxNumberChar(event, maxNumberChar, name) {
            const value = event.replace(/\s/g, '')
            const listNumber = value.split('').filter(item => Number.isInteger(+item))
            this.tabs.card.data[name] = listNumber.length <= maxNumberChar ?  listNumber.join('') : this.tabs.card.data[name]
        },

        setExpirationDate(date) {
            const day = `0${date.getDate()}`,
                month = (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`,
                year = date.getFullYear().toString().substr(-2)
            return `${month}-${day}-${year}`
        },

        async saveSettingsVocabulary(tab) {
            try {
                let data = {}
                data.model = tab.model

                if(tab.selectEdit) {
                    data = Object.assign(data, tab.edit)
                    if(data.model === 'CardInvoice' && !data.number) {
                        data.number = this.options.relations.find(item => item.card_invoice_id === data.id).number
                    }
                    await send(this.$url.financeStatistic.vocabulary_update, 'PUT', { data })
                    tab.edit = {}
                } else {
                    data = Object.assign(data, tab.data)
                    await send(this.$url.financeStatistic.vocabulary_create, 'POST', { data })
                    tab.data = {}
                }
                await this.$store.dispatch('GET_FIN_CARDS')
                await this.getAdditionalData()
            } catch (error) {
                if(error.response) {
                    const response = error.response.data.result
                    this.$refs.createElementCard.setErrors(this.$errors(response))
                }

                new ErrorHandler(error).send
            }
        },

        getRelationsOptions(value, type) {
            if(this.options.relations) {
                const valueRelation = type === 'card' ? this.tabs.card.data[value.relation] : this.tabs.invoice.edit[value.relation]
                const completeRelation = this.options.relations.filter(item => Object.values(item).every(val => val))

                if(valueRelation) {
                    const relations = completeRelation.filter(item => item[value.relation] === valueRelation)
                    return this.getUniqueOptions(relations, value.propertyId)
                } else {
                    return this.getUniqueOptions(completeRelation, value.propertyId)
                }
            }
        },

        getUniqueOptions(array, property) {
            const uniqueArray = []
            if(!array) return uniqueArray
            array.forEach(el => {
                if(!uniqueArray.some(item => item[property] === el[property])) {
                    uniqueArray.push(el)
                }
            })
            return uniqueArray
        },

        getOptions(field, type) {
            if(field.propertyName === 'bank_name') {
                return this.getUniqueOptions(this.options.relations, field.propertyId)
            } else if(field.relation) {
                if(this.tabs[type].edit[field.propertySendToServer]) {
                    return this.options[field.optionName]
                } else {
                    return this.getRelationsOptions(field, type)
                }
            } else {
                return this.options[field.optionName]
            }
        },

        checkPossibilityEditing(data) {
            return !(Object.values(data.edit).filter(el => el).length > 1)
        },

        checkPossibilityRemove(data) {
            return !data.edit.id
        },

        selectedCard(card) {
            const unnecessaryProperties = [
                'affiliate_hash',
                'bank_name',
                'card_number',
                'card_platform_id',
                'card_status_id',
                'created_at',
                'cvv_code',
                'expired',
                'geo_name',
                'holder_name',
                'invoice_number',
                'is_active',
                'is_deleted',
                'owner_name',
                'platform_name',
                'status',
                'type_name'
            ]
            const dataCard = {...card}
            unnecessaryProperties.forEach(prop => delete dataCard[prop])


            this.tabs.card.fields.card_number.validate = this.changeValidationRule(this.tabs.card.fields.card_number.validate, 'required|')
            this.tabs.card.fields.expired.validate = this.changeValidationRule(this.tabs.card.fields.expired.validate, 'required')
            this.tabs.card.fields.cvv_code.validate = this.changeValidationRule(this.tabs.card.fields.cvv_code.validate, 'required|')
            this.tabs.card.data = dataCard
        },

        // async addCards(tab) {
        async addCards() {
            try {
                // const data = {...tab.data}
                const data = {...this.tabs.card.data}
                if(this.popupType === 'editCard') {

                    Object.keys(data).forEach(key => {
                        if(key !== 'id' && data[key] === this.popupData[key]) {
                            data[key] = null
                        }
                    })
                    await send(this.$url.financeStatistic.card_update, 'PUT', { data })
                    EventBus.$emit('emitPopupEvent', {type: 'close'})
                } else {
                    data.expired = this.setExpirationDate(data.expired)
                    await send(this.$url.financeStatistic.card_create, 'POST', { data })
                }
                await this.$store.dispatch('GET_FIN_CARDS')
                tab.data = {}
            } catch (error) {

                // if(error.response) {
                //     const response = error.response.data.result
                //     this.$refs.formAddCard.setErrors(this.$errors(response))
                // }
                new ErrorHandler(error).send
            }
        },

        async removeVocabulary(tab) {
            this.removeAdditionalData = {
                tab,
                id: tab.edit.id,
                model: tab.model
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: 'Confirm',
                text:  `${this.$t('global.remove_data')  }?`,
                accept: this.confirmRemoveVocabulary,
                acceptText: this.$t('global.remove')
            })
        },

        async confirmRemoveVocabulary() {
            try {
                await send(this.$url.financeStatistic.vocabulary_destroy, 'DELETE', { data: {
                    id: this.removeAdditionalData.id,
                    model: this.removeAdditionalData.model
                } })
                this.removeAdditionalData.tab.edit = {}
                await this.getAdditionalData()
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        changeValidationRule(field, rule) {
            return field.replace(rule, '')
        },

        checkExistenceVocabulary(card) {
            Object.keys(this.tabs.card.fields).forEach(key => {
                const field = this.tabs.card.fields[key]
                if(field.visibleValueAtEdit) {
                    if(!this.options[field.optionName].some(item => item[field.propertyId] === card[field.propertySendToServer])) {
                        let newOption = {}
                        if(key === 'card_bank') {
                            newOption = {
                                bank_name: card[field.propertyNameInServer],
                                card_bank_active: 1,
                                card_bank_id: card[field.propertySendToServer],
                                card_invoice_id: card.card_invoice_id,
                                invoice_active: 1,
                                number: card.invoice_number
                            }
                        } else {
                            newOption[field.propertyNameInServer] = card[field.propertyNameInServer]
                            newOption[field.propertyId] = card[field.propertySendToServer]
                        }
                        this.options[field.optionName].push(newOption)
                    }
                }
            })
        },

        async getAdditionalData() {
            this.options = await send(this.$url.financeStatistic.additional_data, 'GET').then(response => ({...response.data.result}))
        }
    },
    async mounted() {
        await this.getAdditionalData()

        if(this.popupType === 'editCard') {
            this.checkExistenceVocabulary(this.popupData)
            this.selectedCard(this.popupData)
        }
    }
}
</script>

<style lang="scss">
    .cards{
        .ul-tabs {
            box-shadow: none !important;
            border-right: none !important;
        }

        .vs-tabs--li button.vs-tabs--btn{
            padding: 10px 0;
        }

        .vs__selected {
            word-break: break-word;
            width: 85%;
        }
        .vs__dropdown-menu{
            max-height: 130px !important;
            overflow-y: auto !important;
        }

        .checkbox__cvv .vs-checkbox {
            width: 15px;
            height: 15px;
        }
        .multiple {
            .vs__selected {
            word-break: break-word;
            width: auto;
            }
        }
    }
    .con-vs-dialog {
        z-index: 999999;
    }

</style>
